/* <clic-scroll-dots data-target=".selector">
 *
 * Page-dot indicator for the theme's NATIVE horizontal scroll rows (the
 * mobile "carousel" layouts that hide their scrollbar — .carousel--mobile,
 * .clic-features__grid, …), mirroring the Flickity page dots the testimonials
 * slider shows. Flickity builds its own dots; this covers the plain
 * overflow-x containers that have no affordance at all.
 *
 * - data-target: selector for the scroll container, resolved within the
 *   closest .shopify-section (falls back to the previous element sibling).
 * - One dot per scroll item (the container's element children); the active
 *   dot tracks the item nearest the scroll-snap start position.
 * - Hides itself entirely when the container doesn't overflow (few items,
 *   tablets) and re-checks on resize. Styling in clic-scroll-dots.css keeps
 *   dots phone-only (<768px), matching where the scroll layouts engage.
 */
(function () {
  'use strict';
  if (customElements.get('clic-scroll-dots')) return;

  customElements.define(
    'clic-scroll-dots',
    class extends HTMLElement {
      connectedCallback() {
        var scope = this.closest('.shopify-section') || document;
        this.target = this.dataset.target
          ? scope.querySelector(this.dataset.target)
          : this.previousElementSibling;
        if (!this.target) return;

        this.onScroll = this.onScroll.bind(this);
        this.rebuild = this.rebuild.bind(this);
        this.ticking = false;

        this.target.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.rebuild);
        document.addEventListener('theme:resize:width', this.rebuild);
        this.rebuild();
      }

      disconnectedCallback() {
        if (this.target) this.target.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.rebuild);
        document.removeEventListener('theme:resize:width', this.rebuild);
      }

      items() {
        return Array.prototype.filter.call(this.target.children, function (el) {
          return el.offsetParent !== null;
        });
      }

      rebuild() {
        var t = this.target;
        var kids = this.items();
        // No overflow → nothing to indicate.
        if (kids.length < 2 || t.scrollWidth <= t.clientWidth + 4) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        if (this.childElementCount !== kids.length) {
          this.innerHTML = '';
          for (var i = 0; i < kids.length; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'clic-scroll-dots__dot';
            dot.setAttribute('aria-label', 'Scroll to item ' + (i + 1) + ' of ' + kids.length);
            dot.addEventListener('click', this.scrollToItem.bind(this, i));
            this.appendChild(dot);
          }
        }
        this.updateActive();
      }

      // Left scroll offset that puts item i at the snap-start position.
      itemOffset(i) {
        var kids = this.items();
        return kids[i].offsetLeft - kids[0].offsetLeft;
      }

      scrollToItem(i) {
        this.target.scrollTo({ left: this.itemOffset(i), behavior: 'smooth' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        var self = this;
        requestAnimationFrame(function () {
          self.ticking = false;
          self.updateActive();
        });
      }

      updateActive() {
        var kids = this.items();
        if (!kids.length) return;
        var pos = this.target.scrollLeft;
        var maxPos = this.target.scrollWidth - this.target.clientWidth;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < kids.length; i++) {
          var d = Math.abs(this.itemOffset(i) - pos);
          if (d < bestDist) {
            bestDist = d;
            best = i;
          }
        }
        // Fully scrolled → last dot, even when the last item can't reach the
        // snap-start position.
        if (maxPos > 0 && pos >= maxPos - 2) best = kids.length - 1;
        var dots = this.children;
        for (var j = 0; j < dots.length; j++) {
          dots[j].classList.toggle('is-selected', j === best);
        }
      }
    }
  );
})();
